import {assertNever} from "@cm/utils"
import {ColorLike} from "@cm/math"
import {HalImageChannelLayout, HalImageDescriptor} from "@cm/hal"

export function isHalDescriptorCompatible(descriptorA: HalImageDescriptor, descriptorB: HalImageDescriptor): boolean {
    // consider "float32" and "float16" to be compatible ("float32" might be used as a fallback if "float16" is not supported)
    const formatA = descriptorA.dataType === "float16" ? "float32" : descriptorA.dataType
    const formatB = descriptorB.dataType === "float16" ? "float32" : descriptorB.dataType
    return (
        descriptorA.width === descriptorB.width &&
        descriptorA.height === descriptorB.height &&
        descriptorA.channelLayout === descriptorB.channelLayout &&
        formatA === formatB
    )
}

export function getChannelLayoutByCount(count: number): HalImageChannelLayout {
    switch (count) {
        case 1:
            return "R"
        case 3:
            return "RGB"
        case 4:
            return "RGBA"
        default:
            throw new Error(`Invalid channel count: ${count}`)
    }
}

export function getChannelCountByLayout(channelLayout: HalImageChannelLayout): number {
    switch (channelLayout) {
        case "R":
            return 1
        case "RGB":
            return 3
        case "RGBA":
            return 4
        default:
            assertNever(channelLayout)
    }
}

export function getVec4Color(color: ColorLike): string {
    return `vec4(${color.r}, ${color.g}, ${color.b}, ${color.a})`
}
